/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import React from 'react';
import { Tag } from '../../../atoms/Tag/Tag';
import { Text } from '../../../atoms/Text/Text';
import './AgentBadgeRendererStyles.scss';
const baseClass = 'qmb-ui-agent-badge-renderer';
export function AgentBadgeRenderer({ block }) {
    const badge = block;
    return (React.createElement("div", { className: baseClass },
        React.createElement(Tag, { label: badge.agent.display_name, variant: "gray", colorStyle: "solid", readOnly: true, icon: badge.agent.icon }),
        badge.role_description && (React.createElement(Text, { variant: "body", className: `${baseClass}__description` }, badge.role_description))));
}
